/**
 * Takes care of the firing of events for the Map class
 */
export default class Eventer {
    constructor(map) {
        this._subscribers = {
            campusChange: [],
            campusKeysError: [],
            campusKeysFetchError: [],
            customStylesFetchError: [],
            geoJSONError: [],
            geoJSONFetchError: [],
            geoJSONLoaded: [],
            piDataLoaded: [],
            serverDataError: [],
            roomClick: [],
            roomHover: [],
            buildingClick: [],
            poiClick: [],
            buildingHover: [],
            layersSourcesInitialized: [],
            customStylingValuesLoaded: [],
        };
        this.lastCampusId = null;
        this._map = map;
    }
    init() {
        this.hookListeners();
    }
    /**
     * Starts the watcher to a map event, which occurs when the map camera is closer to a different campus.
     * Needs to have piData to work.
     */
    initCampusChangeEvent() {
        const setClosestCampusAsCurrentTimer = () => {
            clearTimeout(this.moveEndTimer);
            this.moveEndTimer = setTimeout(setClosestCampusAsCurrent, 500);
        };
        const setClosestCampusAsCurrent = () => {
            const mapCenter = this._map.getCenter();
            const closestCampus = this._map.cuDataManager.campusCollection.getClosestCampusTo([
                mapCenter.lng,
                mapCenter.lat,
            ]);
            if (closestCampus && this.lastCampusId !== closestCampus.id) {
                // if it had been set already, but now is a different one, means campuses changed -> fire
                this.lastCampusId = closestCampus.id;
                this._map.campusCollection.setCurrentCampus(closestCampus.id);
                this.fireEvent("campusChange", closestCampus);
            }
        };
        // one beforehand, even if the map didnt move, so we
        // get an initial currentCampus
        setClosestCampusAsCurrent();
        // then hit the listeners
        this._map.off("moveend", setClosestCampusAsCurrentTimer);
        this._map.on("moveend", setClosestCampusAsCurrentTimer);
    }
    fireEvent(event, arg) {
        this._subscribers[event].forEach((e) => {
            e.cb(arg);
        });
    }
    subscribe(event, id, cb) {
        this.unsubscribe(event, id);
        // @ts-ignore
        this._subscribers[event].push({ cb, id });
    }
    unsubscribe(event, id) {
        // @ts-ignore
        this._subscribers[event] = this._subscribers[event].filter((e) => e.id !== id);
    }
    hookListeners() {
        this._map.on("click", this._map.cuLayerIds.indoorGeoJSONs.rooms, (e) => {
            // let feature: MapboxGeoJSONFeature | undefined;
            let feature;
            if (e.features) {
                feature = e.features[0];
            }
            // this._map.onRoomClick(feature);
            this.fireEvent("roomClick", feature);
        });
        // TODO: outlineclick event is missing
        // this._map.on("click", this._map.cuLayerIds.indoorGeoJSONs.outline, (e) => {
        //   let feature: MapboxGeoJSONFeature | undefined;
        //   if (e.features) {
        //     feature = e.features[0];
        //   }
        //   this.fireEvent("click", feature)
        //   // this._map.onRoomClick(feature);
        // });
        this._map.on("mouseenter", this._map.cuLayerIds.indoorGeoJSONs.rooms, (e) => {
            let feature;
            if (e.features) {
                feature = e.features[0];
            }
            // this._map.onRoomHover(feature);
            this.fireEvent("roomHover", feature);
        });
        this._map.on("click", this._map.cuLayerIds.buildingGeoJSONs.common, (e) => {
            let feature;
            if (e.features) {
                feature = e.features[0];
                this.fireEvent("buildingClick", feature);
            }
        });
        this._map.on("mouseenter", this._map.cuLayerIds.buildingGeoJSONs.common, (e) => {
            let feature;
            if (e.features) {
                feature = e.features[0];
                this.fireEvent("buildingHover", feature);
            }
        });
    }
}
